module.exports = __webpack_public_path__ + "static/media/alert-error.8fa77d90.wav";